import {Component} from '@angular/core';
import {IDataCellDisplayComponent} from '../../../../sdk/src/data-cell-display/idata-cell-display/idata-cell-display.component';
import {Skeleton} from 'primeng/skeleton';
import {TaskUtils} from '../../utils/task.utils';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {MeterItem} from 'primeng/metergroup';
import {CpmCServiceRequestApiModel} from '../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-service-request.api-model';
import {ServiceRequestUtils} from '../../utils/service-request.utils';

/**
 * Task status data cell display component
 */
@Component({
    selector: 'app-service-request-progress-data-cell-display',
    templateUrl: './service-request-progress-data-cell-display.component.html',
    imports: [Skeleton, PrimeNgImportsModule]
})
export class ServiceRequestProgressDataCellDisplayComponent extends IDataCellDisplayComponent<
    CpmCServiceRequestApiModel,
    unknown
> {
    protected readonly TaskUtils = TaskUtils;

    // ===============================================================
    // ===============================================================

    protected _serviceRequest?: CpmCServiceRequestApiModel;
    protected _statusDetail?: MeterItem[];
    protected _statusTooltip?: string;
    protected _completionPct?: number;

    // ===============================================================
    // ===============================================================

    /**
     * On refresh (Error handling and refresh is done in the parent)
     */
    protected override async onRefresh(): Promise<void> {
        if (this.displayType !== 'table')
            throw new Error('Only table is supported for ServiceRequestProgressDataCellDisplayComponent');

        this._serviceRequest = this.row as CpmCServiceRequestApiModel;

        if (this._serviceRequest) {
            const result = ServiceRequestUtils.getProgress(this._serviceRequest);

            this._statusDetail = result.details;
            this._statusTooltip = result.tooltip;
            this._completionPct = result.percentage;
        }
    }
}
